import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {Validators, FormBuilder, FormGroup } from '@angular/forms';
import { User } from 'src/app/model/user.model';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss'],
})
export class UserDetailsComponent implements OnInit {

  @Input() user: User;
  @Input() editing: boolean;
  @Input() confirmLabel: string;
  @Input() cancelLabel: string;

  @Output() cancel = new EventEmitter<any>();
  @Output() perform = new EventEmitter<any>();

  userForm: FormGroup;
  isNewUser = true;

  constructor(private formBuilder: FormBuilder) {
    this.userForm = this.formBuilder.group({
      username: [''],
      firstName: [''],
      lastName: [''],
      email: [''],
      password: [''],
      confirmPassword: [''],
      enabled: [true],
      authorities: ['']
    }, { validators: this.password.bind(this) });
  }

  ngOnInit() {

    if (this.user.username !== undefined && this.user.username != null) {
      this.isNewUser = false;
      // is updating
      this.userForm.get('email').setValidators([Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]);
      this.userForm.get('authorities').setValidators(Validators.required);
      this.userForm.get('firstName').setValidators(Validators.compose([
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(128)]));
      this.userForm.get('lastName').setValidators(Validators.compose([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(128)]));
      this.userForm.get('username').disable();
      this.userForm.get('username').setValue(this.user.username);
      if (this.user.firstName !== undefined && this.user.firstName != null) {
        this.userForm.get('firstName').setValue(this.user.firstName);
      }
      if (this.user.lastName !== undefined && this.user.lastName != null) {
        this.userForm.get('lastName').setValue(this.user.lastName);
      }
      if (this.user.email !== undefined && this.user.email != null) {
        this.userForm.get('email').setValue(this.user.email);
      }
      if (this.user.enabled !== undefined && this.user.enabled != null) {
        this.userForm.get('enabled').setValue(this.user.enabled);
      }
      if (this.user.authorities && this.user.authorities.length > 0) {
        this.userForm.get('authorities').setValue(this.user.authorities[0].authority);
      }
    }
    else {
      this.isNewUser = true;
      this.userForm.get('username').setValidators(Validators.required);
      this.userForm.get('email').setValidators(Validators.compose([Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]));
      this.userForm.get('firstName').setValidators(Validators.compose([
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(128)]));
      this.userForm.get('lastName').setValidators(Validators.compose([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(128)]));
      this.userForm.get('password').setValidators(Validators.compose([Validators.required, Validators.minLength(8)]));
      this.userForm.get('confirmPassword').setValidators([Validators.required, Validators.minLength(8)]);
      this.userForm.get('authorities').setValidators(Validators.required);
    }
  }

  cancelAction() {
    this.cancel.emit();
  }

  performAction() {
    const dto: any = {
      isCreation: false,
      userData: {
        firstName: this.userForm.get('firstName').value,
        lastName: this.userForm.get('lastName').value,
        email: this.userForm.get('email').value,
        enabled: this.userForm.get('enabled').value,
        authorities: [ { authority: this.userForm.get('authorities').value }]
      }
    };
    if (this.isNewUser) {
      dto.isCreation = true;
      dto.userData.username = this.userForm.get('username').value;
      dto.userData.password = this.userForm.get('password').value,
      dto.userData.confirmPassword = this.userForm.get('confirmPassword').value;
    }
    else {
      dto.userData.password = null;
      dto.userData.oldPassword = null;
    }
    this.perform.emit(dto);
  }

  password(formGroup: FormGroup) {
    const { value: password } = formGroup.get('password');
    const { value: confirmPassword } = formGroup.get('confirmPassword');
    return password === confirmPassword ? null : { passwordNotMatch: true };
  }
}
